var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.433,
    height: 24.413,
    viewBox: "0 0 24.433 24.413"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.931 16.295c0 1.5 2.127 2.715 4.752 2.715s4.75-1.215 4.75-2.715h-1.262L19.966 1.881l-.105-.51h-5.7a2.034 2.034 0 00-3.842 0h-5.7l-.107.517a.23.23 0 00-.012.03L1.267 16.283H-.001c0 1.5 2.127 2.715 4.751 2.715s4.749-1.214 4.749-2.715h-1.23L5.217 2.724h5.111a2.039 2.039 0 001.271 1.242l-1.3 18.275h-6.18v2.172h16.244v-2.172h-6.195L12.883 3.966a2.039 2.039 0 001.272-1.242h5.093l-3.02 13.571zm-13.107-.012L4.769 3.209l2.943 13.074zM12.241 2.985a.95.95 0 11.95-.95.951.951 0 01-.95.95zm7.459.2l2.914 13.1h-5.83z",
    fill: "#8a8a8a"
  })));
};

export default SvgWeight;